// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","btn_link":"Header_btn_link__4QWJV","active_link":"Header_active_link__TmDNy"};